import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import StudentDescription from "./StudentDescription";
import "./students-sidebar.css";

const list = [
  {
    title: "Apply for Certificates",
    link: "/students/certificates",
  },
  {
    title: "Notifications",
    link: "/students/notification",
  },
  {
    title: "Downloads",
    link: "/students/downloads",
  },
  {
    title: "Class Routines",
    link: "/students/routines",
  },
  {
    title: "Results",
    link: "/students/results",
  },
  {
    title: "Exam Schedule",
    link: "/students/exam-schedule",
  },
  {
    title: "Student Clubs",
    link: "/students/clubs",
  },
];

class PanduStudents extends Component {
  state = {
    link: "",
    query: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? list.filter((el) => el.title.toLowerCase().includes(query))
      : list;

    return (
      <div className="stud-wrap">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="stud-side">
                <div className="stud-side-head">Students Corner</div>
                <div className="stud-search">
                  <div className="stud-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="stud-search-input"
                      placeholder="Search..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="stud-side-list">
                  {filtered.length === 0 ? (
                    <li className="stud-side-empty">No matching items</li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`stud-side-item${
                          el.link === `/students/${this.state.link}`
                            ? " active"
                            : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="stud-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <StudentDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default PanduStudents;
